import { ComponentProps } from "react";
import { Text } from "components/core/Text";

export const ContentAuthorName = (
  props: Omit<ComponentProps<typeof Text>, "variant">,
) => {
  return <Text variant="body4" color="text.primary" {...props} />;
};
